// @index('./*.png', (f, _) => `import { default as ${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as 专场券 } from './专场券.png'
import { default as 买茶送小黄鸭电器 } from './买茶送小黄鸭电器.png'
import { default as 优惠券 } from './优惠券.png'
import { default as 优米购专场券 } from './优米购专场券.png'
import { default as 去使用 } from './去使用.png'
import { default as 头图 } from './头图.png'
import { default as 已领完 } from './已领完.png'
import { default as 爆款美妆特惠 } from './爆款美妆特惠.png'
import { default as 秒杀专场 } from './秒杀专场.png'
import { default as 立即参与秒杀 } from './立即参与秒杀.png'
import { default as 立即领取 } from './立即领取.png'
// @endindex

export const WomenDayImages = {
  // @index('./*.png', (f, _) => `${_.pascal(f.name)},`)
  专场券,
  买茶送小黄鸭电器,
  优惠券,
  优米购专场券,
  去使用,
  头图,
  已领完,
  爆款美妆特惠,
  秒杀专场,
  立即参与秒杀,
  立即领取,
  // @endindex
}
